import { combineReducers } from 'redux';

import assignment from './assignment';
import isEditing from './isEditing';
import loading from './loading';
import selectedMarkerId from './selectedMarkerId';
import share from './share';
import startDate from './startDate';
import userSelect from './userSelect';

/**
 * @typedef {{
 *    share: import('./share').AuditsUIDetailsShareReducer,
 *    isEditing: boolean,
 *    loading: import('./loading').AuditsUIDetailsLoading,
 *    assignment: import('./assignment').AuditsUIDetailsAssignmentReducer,
 *    startDate: import('./startDate').AuditsUIDetailsStartDateReducer,
 *    userSelect: Record<string, { userIds: string[], links: Array<{ rel: string }>, page: object }>,
 *    selectedMarkerId: string,
 * }} AuditsUIDetailsReducer
 */

export default combineReducers({
  share,
  loading,
  isEditing,
  assignment,
  startDate,
  userSelect,
  selectedMarkerId,
});
